import { DEFAULT_STRING, DEFAULT_NUMBER } from './defaultValues';

export class GeoLocationResponse {
	constructor(axiosResponse) {
		this.response = axiosResponse;

		this.status = this.response?.data?.status || DEFAULT_STRING;
		this.country = this.response?.data?.country || DEFAULT_STRING;
		this.countryCode = this.response?.data?.countryCode || DEFAULT_STRING;
		this.region = this.response?.data?.region || DEFAULT_STRING;
		this.regionName = this.response?.data?.regionName || DEFAULT_STRING;
		this.city = this.response?.data?.city || DEFAULT_STRING;
		this.zip = this.response?.data?.zip || DEFAULT_STRING;
		this.lat = this.response?.data?.lat || DEFAULT_NUMBER;
		this.lon = this.response?.data?.lon || DEFAULT_NUMBER;
		this.timezone = this.response?.data?.timezone || DEFAULT_STRING;
		this.isp = this.response?.data?.isp || DEFAULT_STRING;
		this.org = this.response?.data?.org || DEFAULT_STRING;
		this.as = this.response?.data?.as || DEFAULT_STRING;
		this.query = this.response?.data?.query || DEFAULT_STRING;
	}
}
